module.exports = __webpack_public_path__ + "static/media/close.04fb79ca.svg";